<header
  class="sticky top-0 z-50 flex items-center justify-between py-4 px-6 bg-white shadow-sm"
>
  <!-- Left section with logo and title -->
  <div class="flex items-center header-left gap-4">
    <!-- Back to Dashboard Button (conditionally shown) -->
    <button
      *ngIf="showBackToDashboard"
      (click)="navigateBackToDashboard()"
      class="flex items-center gap-2 px-4 py-2 text-gray-700 hover:text-[#009689] hover:bg-gray-50 rounded-lg transition-colors duration-200"
      [attr.aria-label]="'NAV.BACK_TO_DASHBOARD' | translate"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.00033 11.0827L2.91699 6.99935L7.00033 2.91602"
          stroke="#0A0A0A"
          stroke-width="1.16667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0837 7H2.91699"
          stroke="#0A0A0A"
          stroke-width="1.16667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <span class="font-medium text-md">{{
        "NAV.BACK_TO_DASHBOARD" | translate
      }}</span>
    </button>

    <img
      (click)="onLogoClick()"
      src="assets/images/ina-logo.svg"
      alt="INA Logo"
      class="h-12 cursor-pointer"
    />
    <div
      *ngIf="!isLandingPage"
      [ngClass]="{
        'border-l border-gray-200 pl-4 ml-4': !isRtl && !showBackToDashboard,
        'border-r border-gray-200 pr-4 mr-4 text-right':
          isRtl && !showBackToDashboard,
        'arabic-text': isRtl
      }"
    >
      <h1 class="text-2xl font-semibold text-gray-800 page-title">
        {{ currentRoute | translate }}
      </h1>
      <div *ngIf="currentSubtitle" class="subtitle">
        {{ currentSubtitle | translate }}
      </div>
    </div>
  </div>

  <!-- Center: Menu Links -->
  <nav
  *ngIf="isLandingPage"
  class="hidden md:flex items-center justify-start lg:gap-10 gap-4 text-gray-700 font-medium flex-1 bg-white"
>
  <a
    routerLink="/"
    [routerLinkActiveOptions]="{ exact: true }"
    routerLinkActive="text-[#009689] !border-[#009689] transition-all duration-1000 inline-block"
    class="hover:text-[#009689] pb-1 border-b-2 border-transparent"
  >
    {{ "NAV.HOME" | translate }}
  </a>

  <a
    routerLink="/about"
    routerLinkActive="text-[#009689] !border-[#009689] transition-all duration-1000 inline-block"
    class="hover:text-[#009689] pb-1 border-b-2 border-transparent"
  >
    {{ "NAV.ABOUT_US" | translate }}
  </a>

  <a
    routerLink="/contact"
    routerLinkActive="text-[#009689] !border-[#009689] transition-all duration-1000 inline-block"
    class="hover:text-[#009689] pb-1 border-b-2 border-transparent"
  >
    {{ "NAV.CONTACT" | translate }}
  </a>

  <a
    routerLink="/faq"
    routerLinkActive="text-[#009689] !border-[#009689] transition-all duration-1000 inline-block"
    class="hover:text-[#009689] pb-1 border-b-2 border-transparent"
  >
    {{ "NAV.FAQ" | translate }}
  </a>
</nav>


  <!-- Right section -->
  <div class="flex items-center gap-4 header-right">
    <!-- Progress Bar -->
    <div
      *ngIf="showProgressBar"
      class="progress-container"
      [ngClass]="{
        'rtl-progress': isRtl
      }"
    >
      <div class="flex items-center">
        <div class="progress-info mt-1">
          <span class="text-sm text-gray-600 mr-2">{{
            "PROGRESS.LABEL" | translate
          }}</span>
          <span class="text-sm font-semibold text-teal-600 mr-2"
            >{{ progress }}%</span
          >
        </div>
        <div class="w-32 bg-gray-200 rounded-full h-2">
          <div
            class="bg-teal-600 h-2 rounded-full transition-all duration-500"
            [style.width.%]="progress"
          ></div>
        </div>
      </div>
    </div>
    <!-- Language Switcher -->
    <div class="flex items-center rounded-2xl bg-gray-100 p-1">
      <button
        (click)="switchLanguage('ar')"
        class="px-4 py-2 rounded-xl font-medium transition-colors duration-200"
        [ngClass]="{
          'bg-white text-gray-700': currentLang === 'ar',
          'text-gray-700': currentLang !== 'ar'
        }"
      >
        العربية
      </button>
      <button
        (click)="switchLanguage('en')"
        class="px-4 py-2 rounded-xl font-medium transition-colors duration-200"
        [ngClass]="{
          'bg-white text-gray-700': currentLang === 'en',
          'text-gray-700': currentLang !== 'en'
        }"
      >
        English
      </button>
    </div>

    <!-- Auth Buttons -->
    <div class="flex items-center gap-3">
      <button
        *ngIf="!isAuthenticated && isLandingPage"
        (click)="openKeyClockLogin()"
        class="bg-white text-[#009689] px-6 py-2 rounded-lg font-medium shadow-md border border-[#009689] transition-colors duration-200"
      >
        {{ "NAV.LOGIN" | translate }}
      </button>

      <button
        *ngIf="!isAuthenticated && isLandingPage"
        (click)="openKeyClockLogin()"
        class="bg-[#009689] text-white px-6 py-2 rounded-lg font-medium shadow-md border border-[#009689] transition-colors duration-200"
      >
        {{ "NAV.SIGNUP" | translate }}
      </button>

      <button
        *ngIf="isAuthenticated && isLandingPage"
        (click)="navigateToDashboard()"
        class="bg-[#00BBA7] text-white px-6 py-2 rounded-lg font-medium shadow-md transition-colors duration-200"
      >
        {{ "NAV.GOTODASHBOARD" | translate }}
      </button>
    </div>

    <div class="user-dropdown-container" *ngIf="isAuthenticated">
      <button
        (click)="toggleUserDropdown($event)"
        class="flex items-center gap-2 focus:outline-none"
        aria-expanded="false"
        aria-label="User menu"
        aria-haspopup="true"
      >
        <div
          class="w-10 h-10 shadow-lg rounded-xl bg-[#00BBA7] flex items-center justify-center text-white font-medium"
          [title]="userFullName"
        >
          {{ userInitials }}
        </div>
      </button>
    </div>
  </div>
</header>
